const InternalFaqs = [
  {
    question: 'faq.internal.question1',
    answer: [
      [
        'faq.internal.q1.answer1',
        'faq.internal.q1.answer2',
        'faq.internal.q1.answer3',
        'faq.internal.q1.answer4',
        'faq.internal.q1.answer5',
      ],
    ],
  },
  {
    question: 'faq.internal.question2',
    answer: [
      'faq.internal.q2.answer1',
      ['faq.internal.q2.answer2', 'faq.internal.q2.answer3'],
      'faq.internal.q2.answer4',
      ['faq.internal.q2.answer5', 'faq.internal.q2.answer6'],
      'faq.internal.q2.answer7',
      ['faq.internal.q2.answer8', 'faq.internal.q2.answer9'],
    ],
  },
  {
    question: 'faq.internal.question3',
    answer: ['faq.internal.q3.answer1'],
  },
  {
    question: 'faq.internal.question4',
    answer: ['faq.internal.q4.answer1', 'faq.internal.q4.answer2'],
  },
  {
    question: 'faq.internal.question5',
    answer: [
      [
        'faq.internal.q5.answer1',
        'faq.internal.q5.answer2',
        'faq.internal.q5.answer3',
        'faq.internal.q5.answer4',
      ],
    ],
    notes: 'faq.internal.q5.answer5',
  },
  {
    question: 'faq.internal.question6',
    answer: [
      'faq.internal.q6.answer1',
      ['faq.internal.q6.answer2', 'faq.internal.q6.answer3'],
      'faq.internal.q6.answer4',
      ['faq.internal.q6.answer5', 'faq.internal.q6.answer6'],
      'faq.internal.q6.answer7',
      ['faq.internal.q6.answer8', 'faq.internal.q6.answer9'],
    ],
  },
  {
    question: 'faq.internal.question7',
    answer: [
      'faq.internal.q7.answer1',
      ['faq.internal.q7.answer2'],
      'faq.internal.q7.answer3',
      ['faq.internal.q7.answer4', 'faq.internal.q7.answer5'],
      'faq.internal.q7.answer6',
      ['faq.internal.q7.answer7', 'faq.internal.q7.answer8'],
    ],
  },
  {
    question: 'faq.internal.question8',
    answer: ['faq.internal.q8.answer1'],
  },
  {
    question: 'faq.internal.question9',
    answer: ['faq.internal.q9.answer1'],
  },
  {
    question: 'faq.internal.question10',
    answer: ['faq.internal.q10.answer1', 'faq.internal.q10.answer2'],
  },
  {
    question: 'faq.internal.question11',
    answer: [
      'faq.internal.q11.answer1',
      ['faq.internal.q11.answer2', 'faq.internal.q11.answer3'],
      'faq.internal.q11.answer4',
    ],
  },
  {
    question: 'faq.internal.question12',
    answer: ['faq.internal.q12.answer1'],
  },
  {
    question: 'faq.internal.question13',
    answer: ['faq.internal.q13.answer1'],
  },
  {
    question: 'faq.internal.question14',
    answer: [['faq.internal.q14.answer1', 'faq.internal.q14.answer2']],
  },
  {
    question: 'faq.internal.question15',
    answer: ['faq.internal.q15.answer1', 'faq.internal.q15.answer2'],
  },
  {
    question: 'faq.internal.question16',
    answer: ['faq.internal.q16.answer1'],
    notes: 'faq.internal.q16.answer2',
  },
  {
    question: 'faq.internal.question17',
    answer: [
      'faq.internal.q17.answer1',
      'faq.internal.q17.answer2',
      ['faq.internal.q17.answer3', 'faq.internal.q17.answer4'],
      'faq.internal.q17.answer5',
      ['faq.internal.q17.answer6', 'faq.internal.q17.answer7'],
    ],
  },
  {
    question: 'faq.internal.question18',
    answer: [
      'faq.internal.q18.answer1',
      [
        'faq.internal.q18.answer2',
        'faq.internal.q18.answer3',
        'faq.internal.q18.answer4',
        'faq.internal.q18.answer5',
      ],
    ],
  },
  {
    question: 'faq.internal.question19',
    answer: ['faq.internal.q19.answer1', 'faq.internal.q19.answer2'],
  },
  {
    question: 'faq.internal.question20',
    answer: ['faq.internal.q20.answer1'],
  },
]

export { InternalFaqs }
